import {getSiteConfig} from '../api/styleConfig';
import {getLandingConfig} from '../api/formLanding';

const initialState = {
  siteConfig: null,
  planSeleccionado: '',
  stepVisible: '',
  steps: [],
  error: null,
  landingConfig: null,
  dynamicLink: null,
  formValues: {},
};

const CONFIG = 'CONFIG';
const SELECTEDPLAN = 'SELECTEDPLAN';
const STEPVISIBLE = 'STEPVISIBLE';
const ADD_ITEM = 'ADD_ITEM';
const ERROR = 'ERROR';
const LANDINGCONFIG = 'LANDINGCONFIG';
const DYNAMICLINK = 'DYNAMICLINK';
const SET_FORM_VALUES = 'SET_FORM_VALUES';

const setConfig = (config) => ({type: CONFIG, payload: config});
const setearPlan = (plan) => ({type: SELECTEDPLAN, payload: plan});
const setearStepVisible = (plan) => ({type: STEPVISIBLE, payload: plan});
const sumarStep = (plan) => ({type: ADD_ITEM, payload: plan});
const setError = (error) => ({type: ERROR, payload: error});
const setearLandingConfig = (landingConfig) => ({
  type: LANDINGCONFIG,
  payload: landingConfig,
});
const setearDinamikLink = (dynamicLink) => ({
  type: DYNAMICLINK,
  payload: dynamicLink,
});

export const fetchConfig = () => {
  return async (dispatch) => {
    const res = await getSiteConfig();
    if (res !== 'error') {
      return dispatch(setConfig(res.data));
    } else {
      return dispatch(setError(res));
    }
  };
};

export const fetchLandingConfig = () => {
  return (dispatch) => {
    return getLandingConfig()
      .then((res) => {
        return dispatch(setearLandingConfig(res));
      })
      .catch((res) => {
        return dispatch(setError(res));
      });
  };
};

export const setPlan = (plan) => {
  return (dispatch) => {
    return dispatch(setearPlan(plan));
  };
};

export const setStepVisible = (step) => {
  return (dispatch) => {
    return dispatch(setearStepVisible(step));
  };
};

export const addStep = (step) => {
  return (dispatch) => {
    return dispatch(sumarStep(step));
  };
};

export const setDinamikLink = (link) => {
  return (dispatch) => {
    return dispatch(setearDinamikLink(link));
  };
};

export const setFormValues = (values) => {
  return (dispatch) => {
    return dispatch({type: SET_FORM_VALUES, payload: values});
  };
};


const configReducer = (state = initialState, action) => {
  switch (action.type) {
    case CONFIG:
      return {...state, siteConfig: action.payload};
    case LANDINGCONFIG:
      return {...state, landingConfig: action.payload};
    case SELECTEDPLAN:
      return {...state, planSeleccionado: action.payload};
    case STEPVISIBLE:
      return {...state, stepVisible: action.payload};
    case ERROR:
      return {...state, error: action.payload};
    case DYNAMICLINK:
      return {...state, dynamicLink: action.payload};
    case ADD_ITEM:
      return {
        ...state,
        steps: [...state.steps, action.payload],
      };
    case SET_FORM_VALUES:
      return {
        ...state,
        formValues: {
          ...state.formValues,
          ...action.payload, // mergea los nuevos valores con los existentes
        },
      };
    default:
      return {...state};
  }
};

export default configReducer;
